import { CpInsuredPersonInterface } from '../../../interfaces/dto/insured-person/cp-insured-person-interface';
import { CpBenefitsModel } from '../benefits/cp-benefits-model';
import { CpClinicalExclusionModel } from '../clinical-exclusion/cp-clinical-exclusion-model';
import { CpClinicalPenaltyModel } from '../clinical-penalty/cp-clinical-penalty-model';

export class CpInsuredPersonModel implements CpInsuredPersonInterface {
  Birthdate: string = '';
  CardNumber: string = '';
  FiscalNumber: string = '';
  FiscalNumberPrefix: string = '';
  Name: string = '';
  Mobile: string = '';
  Email: string = '';
  Relationship: string = '';
  FiscalNumberCountryCode: string = '';
  Iban: string = '';
  NationalCardNumberCountryCode: string = '';
  StartDate: string = '';
  Benefits: CpBenefitsModel[] = new Array<CpBenefitsModel>();
  ClinicalExclusions: CpClinicalExclusionModel[] = new Array<CpClinicalExclusionModel>();
  ClinicalPenalties: CpClinicalPenaltyModel[] = new Array<CpClinicalPenaltyModel>();
  Address?: string = '';
  PostalCode?: string = '';
  City?: string = '';
  CommercialPremium?: string = '';
  TotalPremium?: string = '';

  constructor(init?: Partial<CpInsuredPersonModel>) {
    Object.assign(this, init);
  }
}
